import type { LucideIcon } from 'lucide-react'
import { routeById } from '@/config/routeManifest'

export function getTabIcon(routeId: string): LucideIcon | null {
  return routeById(routeId)?.icon ?? null
}
